import React, { Fragment, useContext, useMemo } from 'react';
import * as UI from './styles';
import physics from '../../assets/icons/physics.svg';
import AppThemeContext from '../../contexts/theme';
import Avatar from 'react-avatar';
import { useAuth } from '../../contexts/auth';
import { ChemistryIcon, MedCoinIcon } from '../Icon';

function HeaderDefault() {
  const {
    theme: { title, colors },
  } = useContext(AppThemeContext);

  const { user, updateTime } = useAuth();

  const medCoins = useMemo(() => {
    console.log(updateTime);
    return <Fragment>
      <MedCoinIcon style={{ marginLeft: 20, fontSize: '3.5rem' }} />
      <span className="stat">{user?.coins}</span>
    </Fragment>
  }, [user?.coins, updateTime])


  return (
    <UI.Container logged={!!user} >
      <UI.LeftSection>
        {title === 'chemistry' ? <ChemistryIcon style={{ fontSize: '3rem' }} /> : <img src={physics} alt="Logo matéria" />}
        <span>{title === 'chemistry' ? 'Química' : 'Física'}</span>
      </UI.LeftSection>

      <UI.RightSect>
        <div style={{
          width: 47,
          height: 49,
          display: 'flex',
          justifyContent: 'center',
          borderRadius: 30,
          border: `0.4rem solid ${colors.primary}`,
        }}>
          <Avatar
            size="50"
            textSizeRatio={2.8}
            color="#5D5D5D"
            round
            name={user?.name}
          />
        </div>
        <span className="stat">{user?.name}</span>
        {/* <img id="medcoin" src={medCoins} alt="MedCoins" /> */}
        {medCoins}
      </UI.RightSect>
    </UI.Container>
  );
}

export default HeaderDefault;
